import { createFileRoute } from '@tanstack/react-router'

import { HistoryPage } from '@/components/Internal/History/HistoryPage'

export const Route = createFileRoute('/internal/system/operations/history')({
  component: HistoryPage,
})
